import Usuario from "model/administracao/cadastro/Usuario";

export default class FinalizarElaboracao {
    idVersao: number;
    responsavelAprovacao: Usuario | null;
    prazoAprovacao: Date | null;
    responsavelRevisao: Usuario | null;
    prazoRevisao: Date | null;
    versaoInicial: number;

    constructor(
        idVersao = 0,
        responsavelAprovacao = null,
        prazoAprovacao = new Date(),
        responsavelRevisao = null,
        prazoRevisao = new Date(),
        versaoInicial = 0
        
    ) {
        this.idVersao = idVersao;
        this.responsavelAprovacao = responsavelAprovacao;
        this.prazoAprovacao = prazoAprovacao;
        this.responsavelRevisao = responsavelRevisao;
        this.prazoRevisao = prazoRevisao;
        this.versaoInicial = versaoInicial;
    }
}